import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
`;

export const ShareLinkImage = styled.div`
    display: flex;
`;

export const Text = styled.div`
    display: flex;
    margin-top: 20px;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
`;

export const PhoneNumberWrapper = styled.div`
    display: flex;
    margin-top: 8px;
`;

export const PhoneNumber = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const EditIcon = styled.div`
    display: flex;
    margin-left: 5px;
`;

export const LinkWrapper = styled.div`
    display: flex;
    background: #ffffff;
    border: 1px solid #e7e7f0;
    border-radius: 8px;
    margin-top: 16px;
    padding: 12px;
    word-break: break-all;
`;

export const CopyLink = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
`;

export const Link = styled.div`
    display: flex;
    flex: 6;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    color: #1b73e8;
`;

export const SendButtonWrapper = styled.div`
    margin-top: 40px;
`;
